import Service, { service } from '@ember/service';
import type CableService from './cable.ts';

export type Appearance = {
  name: string;
  personId: string;
  documentId: string;
  type: string;
};

export default class AppearanceService extends Service {
  @service declare cable: CableService;

  private channelParams: object | null = null;

  /**
   * @deprecated Cable connection is now managed centrally.
   * Apps should call cable.configure() at startup instead.
   */
  connect(apiHost: string, apiKey: string, token: string) {
    this.cable.connect(apiHost, apiKey, token);
  }

  subscribe(type: string, documentId: string, onUpdate: (msg: Record<string, Appearance>) => void) {
    this.channelParams = {
      channel: 'AppearanceChannel',
      type,
      document_id: documentId,
    };

    this.cable.subscribe(this.channelParams, {
      received: (msg) => {
        onUpdate(msg as Record<string, Appearance>);
      },
    });
  }

  unsubscribe(_type: string, _documentId: string) {
    if (this.channelParams) {
      this.cable.unsubscribe(this.channelParams);
      this.channelParams = null;
    }
  }
}
